module.exports = {
    PROJECT: {
        NAME: 'Lomas Don Quifo',
        SLOGAN: 'Tu hogar, en el corazón de la montaña.',
        DESCRIPTION_1: 'A pocos minutos de la hermosa ciudad de Constanza, nace Lomas Don Quifo, un proyecto que ofrece amplios solares para quienes buscan un refugio personal en plena conexión con la naturaleza. Aquí, la tranquilidad y el aire puro se combinan con vistas impresionantes y una experiencia única de vida en armonía con el entorno.',
        DESCRIPTION_2: 'Además de los espaciosos solares, Lomas Don Quifo te invita a disfrutar de senderos rodeados de verdor, cultivos locales que conectan con las tradiciones de la región, y ríos cristalinos que brindan frescura y serenidad. Cada rincón de este lugar ha sido pensado para ofrecerte momentos de paz y aventura en un entorno natural incomparable.',
        DESCRIPTION_3: 'Descubre Lomas Don Quifo: un lugar donde la naturaleza, la tranquilidad y la autenticidad se unen para darte el estilo de vida que siempre soñaste.',
        EMAIL: 'lomasdonquifo@gmail.com'
    },
    MAPS_API_KEY: 'AIzaSyDqUt8xQNAbugbeLacgiVWtdEy3viIJQ5Y',
    LOTES_STATUS: {
        AVAILABLE: 'Disponible',
        SOLD: 'Vendido',
    }
}
